module.exports = __webpack_public_path__ + "img/denied-ringer.25b90b74.svg";